// extracted by mini-css-extract-plugin
export default {"introduction":"gOc26hIljiwVQo8fXDMg","content":"KynTVXXwTY6PU9Yfd6hH","infoNote":"YlT5Fp2E3i0jjag5hcTY","introductionContainer":"cABwmtauwEwjuRsCtGEV"};